import React from "react"
import { Link } from "gatsby"
import { MDXRenderer } from "gatsby-plugin-mdx"
// import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { motion } from "framer-motion"

const Code = ({ size = 24, color = "#000000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="stroke-current h-8 w-8 flex-shrink-0"
  >
    <path d="m16 18 6-6-6-6M8 6l-6 6 6 6" />
  </svg>
)

function FadeInWhenVisible({ children }) {
  return (
    <motion.div
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ duration: 0.5 }}
      variants={{
        visible: { opacity: 1, scale: 1 },
        hidden: { opacity: 0, scale: 0 },
      }}
    >
      {children}
    </motion.div>
  )
}

const ExternalLink = ({ size = 24, color = "#000000" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    fill="none"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="stroke-current fill-current h-8 w-8 flex-shrink-0"
  >
    <g fill="none" fill-rule="evenodd">
      <path d="M18 14v5a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8c0-1.1.9-2 2-2h5M15 3h6v6M10 14L20.2 3.8" />
    </g>
  </svg>
)

const FeaturedProject = ({ content }) => {
  return (
    <section
      id="projects"
      className="w-11/12 lg:w-6/2 xl:w-7/12 mx-auto my-14 md:my-24 xl:my-48"
    >
      <p className="font-body2 text-3xl md:text-4xl lg:text-5xl font-bold mb-12 uppercase text-center tracking-wider text-transparent bg-clip-text bg-gradient-to-r from-blue-800 via-blue-500 to-gray-900 dark:from-gray-700 dark:via-gray-300 dark:to-white">
        Projects
      </p>
      <ul className="w-full snap-y mt-24">
      {content.map((project, key) => {
        const { body, frontmatter } = project.node
        const idx = frontmatter.position
        return (
          <FadeInWhenVisible>
            <li
              className="p-8 mb-4 lg:mb-8 lg:flex mx-auto justify-between bg-blue-100 dark:bg-secondary lg:hover:bg-blue-100 lg:dark:hover:bg-secondary rounded-xl snap-center"
              key={idx}
            >
                <div className="lg:hidden mb-4 lg:mb-0 relative overflow-hidden w-full">
                  <div className="mx-auto flex-shrink-0 relative w-60 h-52">
                  <div class="box box-content left-6 top-9">
                    <div class="ribbon"><span>Featured</span></div>
                  </div>
                    <img src={frontmatter.thumbnailUrl} className="aspect-[1/1] object-cover object-center h-full w-full" alt={frontmatter.title} />
                  </div>
                </div>
              <div className="lg:w-1/2">
                {/* <h1 className="text-md md:text-xl font-bold uppercase lg:text-transparent lg:bg-clip-text lg:bg-gradient-to-br lg:from-blue-600 lg:via-blue-400 lg:to-purple-800 lg:dark:from-gray-500 lg:dark:via-gray-300 lg:dark:to-white">
                  {frontmatter.category}
                </h1> */}
                <h1 className="font-body2 text-xl md:text-2xl lg:text-3xl font-bold mb-6 text-quarternary">
                  {frontmatter.title}
                </h1>
                <div className="flex justify-between">
                  <div className="container">
                    <p className="font-body2 font-light text-base sm:text-lg mb-6">
                      <MDXRenderer>{body}</MDXRenderer>
                    </p>

                    <div className="w-full whitespace-nowrap overflow-hidden flex flex-wrap text-sm md:text-md lg:text-lg font-bold lg:text-transparent lg:bg-clip-text lg:bg-gradient-to-br lg:from-blue-600 lg:via-blue-400 lg:to-purple-800 lg:dark:from-gray-500 lg:dark:via-gray-300 lg:dark:to-white">
                      {frontmatter.tags.map((tag, key) => {
                        return <p className="mr-2 font-mono uppercase">{tag}</p>
                      })}
                    </div>
                    {frontmatter.live === "true" ? (
                      <div className="justify-between flex mx-auto mt-4">
                        <span className="transition duration-300 ease-in-out text-blue-400 hover:text-blue-700 dark:text-gray-400 dark:hover:text-white">
                          <a
                            href={frontmatter.external}
                            rel="noreferrer noopener"
                            target="_blank"
                            aria-label="See my demo project live"
                          >
                            <ExternalLink />
                          </a>
                        </span>
                      </div>
                    ) : (
                      <div className="flex flex-row space-x-4 mt-4">
                        <span className="transition duration-300 ease-in-out text-blue-400 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white">
                          <a
                            href={frontmatter.github}
                            rel="noreferrer noopener"
                            target="_blank"
                            aria-label="See my demo project source code on github."
                          >
                            <Code />
                          </a>
                        </span>
                        <span className="transition duration-300 ease-in-out text-blue-400 hover:text-blue-600 dark:text-gray-400 dark:hover:text-white">
                          <a
                            href={frontmatter.external}
                            rel="noreferrer noopener"
                            target="_blank"
                            aria-label="See my demo project live"
                          >
                            <ExternalLink />
                          </a>
                        </span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
              <div className="hidden lg:block">
                <div class="box left-11 top-4">
                  <div class="ribbon"><span>Featured</span></div>
                </div>
                {/* <GatsbyImage 
                  image={image} 
                  alt={frontmatter.title}
                  imgStyle={{ objectFit: "cover" }} 
                /> */}
                <div className="relative w-96 h-60">
                  <img src={frontmatter.thumbnailUrl} className="aspect-[1/1] object-cover object-center h-full w-full" alt={frontmatter.title} />
                </div>
              </div>
            </li>
          </FadeInWhenVisible>
        )
      })}
      </ul>
      {/* <FadeInWhenVisible> */}
        <Link to="/project" className="flex justify-center">
          <button className="mt-10 inline-block w-auto font-bold text-sm sm:text-md md:text-lg lg:text-2xl cursor-pointer transition duration-300 ease-in-out transform hover:-translate-y-1 hover:scale-100 border-2 border-blue-200 dark:border-gray-600  hover:border-blue-500 dark:hover:border-white rounded-full">
            <div class="flex flex-cols-1">
                <span className="relative flex items-center justify-center w-full h-full whitespace-nowrap text-secondary-text hover:text-quarternary px-6 py-4 space-x-3 md:px-11 md:py-6 md:space-x-5">See more</span>
            </div> 
          </button>
        </Link>
      {/* </FadeInWhenVisible> */}
    </section>
  )
}

export default FeaturedProject
